import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@infra/auth/auth.guard';
import { AtendimentosComponent } from '@modules/atendimentos/pages/atendimentos/atendimentos.component';
import { AlterarKmComponent } from '@modules/alterar-km/pages/alterar-km/alterar-km.component';
import { InspecoesComponent } from '@modules/inspecoes/pages/inspecoes/inspecoes.component';
import { AlterarSenhaComponent } from '@modules/auth/pages/alterar-senha/alterar-senha.component';
import { LoginComponent } from '@modules/auth/pages/login/login.component';
import { LogoutComponent } from '@modules/auth/pages/logout/logout.component';
import { RecuperarSenhaComponent } from '@modules/auth/pages/recuperar-senha/recuperar-senha.component';
import { CondutoresComponent } from '@modules/condutores/pages/condutores/condutores.component';
import { MinhaContaComponent } from '@modules/configuracoes/pages/minha-conta/minha-conta.component';
import { FaturamentoComponent } from '@modules/faturamento/pages/faturamento/faturamento.component';
import { FrotaContratadaComponent } from '@modules/frota-contratada/pages/frota-contratada/frota-contratada.component';
import { MedicaoComponent } from '@modules/medicoes/pages/medicoes/medicoes.component';
import { MultasComponent } from '@modules/multas/pages/multas/multas.component';
import { NotificacoesComponent } from '@modules/notificacoes/pages/notificacoes/notificacoes.component';
import { PneusComponent } from '@modules/pneus/pages/pneus/pneus.component';
import { ServicosExecutadosComponent } from '@modules/servicos-executados/pages/servicos-executados/servicos-executados.component';
import { DashboardComponent } from '@modules/dashboard/pages/dashboard/dashboard.component';
import { PrimeiroAcessoGuard, PublicGuard } from '@shared/guards';

/**
 * Definir as rotas da aplicação em ordem do menu lateral
 */
const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard, PrimeiroAcessoGuard],
  },
  {
    path: 'atendimentos',
    component: AtendimentosComponent,
    canActivate: [AuthGuard, PrimeiroAcessoGuard],
  },
  {
    path: 'atualizacao-km',
    component: AlterarKmComponent,
    canActivate: [AuthGuard, PrimeiroAcessoGuard],
  },
  {
    path: 'inspecoes',
    component: InspecoesComponent,
    canActivate: [AuthGuard, PrimeiroAcessoGuard],
  },
  {
    path: 'condutores',
    component: CondutoresComponent,
    canActivate: [AuthGuard, PrimeiroAcessoGuard],
  },
  {
    path: 'frota-contratada',
    component: FrotaContratadaComponent,
    canActivate: [AuthGuard, PrimeiroAcessoGuard],
  },
  {
    component: FaturamentoComponent,
    path: 'faturamento',
    canActivate: [AuthGuard, PrimeiroAcessoGuard],
  },
  {
    component: MedicaoComponent,
    path: 'medicoes',
    canActivate: [AuthGuard, PrimeiroAcessoGuard],
  },
  {
    path: 'multas',
    component: MultasComponent,
    canActivate: [AuthGuard, PrimeiroAcessoGuard],
  },
  {
    path: 'servicos-executados',
    component: ServicosExecutadosComponent,
    canActivate: [AuthGuard, PrimeiroAcessoGuard],
  },
  {
    path: 'pneus',
    component: PneusComponent,
    canActivate: [AuthGuard, PrimeiroAcessoGuard],
  },
  {
    path: 'notificacoes',
    component: NotificacoesComponent,
    canActivate: [AuthGuard, PrimeiroAcessoGuard],
  },
  {
    path: 'minha-conta',
    component: MinhaContaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'logout',
    component: LogoutComponent,
    canActivate: [],
  },
  {
    path: ':id/recuperar-senha',
    component: RecuperarSenhaComponent,
    canActivate: [PublicGuard],
  },
  {
    path: ':id/alterar-senha',
    component: AlterarSenhaComponent,
    canActivate: [PublicGuard],
  },
  {
    path: ':id',
    component: LoginComponent,
    canActivate: [PublicGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
